import React from 'react'
import { FaDiscord, FaFacebookF, FaInstagram, FaTiktok, FaTumblr, FaTwitter, FaYoutube, } from 'react-icons/fa'
import SocialLink from './SocialLink'
import './socialmenu.css'
import { FaTwitch } from 'react-icons/fa6'

const SocialMenu = ({social}) => {

      if(social.code) return 

      return (
            <div className="social_content flex">
                  <SocialLink link={social.facebook} classObj={`facebook`} icon={<FaFacebookF />} />
                  <SocialLink link={social.twitter} classObj={`twitter`} icon={<FaTwitter />} />
                  <SocialLink link={social.instagram} classObj={`instagram`} icon={<FaInstagram />} />
                  <SocialLink link={social.youtube} classObj={`youtube`} icon={<FaYoutube />} />
                  <SocialLink link={social.tiktok} classObj={`tiktok`} icon={<FaTiktok />} />
                  <SocialLink link={social.tumblr} classObj={`tumblr`} icon={<FaTumblr />} />
                  <SocialLink link={social.discord} classObj={`discord`} icon={<FaDiscord />} />
                  <SocialLink link={social.twitch} classObj={`twitch`} icon={<FaTwitch />} />
            </div>
      )
}

export default SocialMenu
